import styled from 'styled-components';

import { Card } from '@material-ui/core';

export const StyledCard = styled(Card)`
  padding: ${({ theme }) => `${theme.spacing(3)}px`};
`;
